import { Trans } from "@lingui/macro";
import { UiBox, UiDivider, UiSwitch, UiTypography } from "@smp/ui";

import { useContextApp } from "@/screens/app/context/app";

import { useContextDialogPurchase } from "../../../context";

export const Recurring = () => {
  const {
    state: { me, recurringPaymentActive },
  } = useContextApp();

  const {
    actions: { paymentTypeSelectedChange },
    state: { paymentTypeSelected, productSelected },
  } = useContextDialogPurchase();

  const handleToggle = () => {
    paymentTypeSelectedChange(
      paymentTypeSelected === "recurring" ? "single" : "recurring",
    );
  };

  if (productSelected.type !== "plan-product") {
    return null;
  }

  if (["europe", "cis", "world"].includes(me.billing_policy_id)) {
    return null;
  }

  if (recurringPaymentActive) {
    return null;
  }

  return (
    <UiBox display="flex" flexDirection="column" mb={4}>
      <UiBox mb={2}>
        <UiTypography variant="h4">
          <Trans>Plan subscription</Trans>
        </UiTypography>
      </UiBox>
      <UiBox mb={2}>
        <UiSwitch
          checked={paymentTypeSelected === "recurring"}
          label={<Trans>Recurring Payment</Trans>}
          onClick={handleToggle}
        />
      </UiBox>
      <UiBox mt={2}>
        <UiDivider />
      </UiBox>
    </UiBox>
  );
};
